import React from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
//@ts-ignore
import { actions as LKModalActions } from 'shared/LKModal'
import { usePermissions } from 'shared'

export const useModalActions = () => {
  const dispatch = useDispatch()

  const openModal = React.useCallback(
    (
      name: string,
      params: {
        [key: string]: any
      },
    ) => {
      dispatch(LKModalActions.open({ name, ...params }))
    },
    [dispatch],
  )

  const openErrorModal = React.useCallback(
    (text) => {
      dispatch(LKModalActions.openError(text))
    },
    [dispatch],
  )

  return {
    dispatch,
    openModal,
    openErrorModal,
  }
}

export const useHistoryPush = () => {
  const history = useHistory()

  return React.useCallback(
    (link: string) => {
      if (link) {
        history.push(link)
      }
    },
    [history],
  )
}

export const usePermissionCheck = () => {
  const permissions = usePermissions()

  const checkPermission = React.useCallback(
    (permission: string | string[], oneOfPermissions?: string[]) => {
      if (permission) {
        if (Array.isArray(permission)) {
          return permission.every((i) => permissions[i])
        }

        return permissions[permission]
      }

      if (Array.isArray(oneOfPermissions)) {
        return oneOfPermissions.some((item) => permissions[item])
      }

      return true
    },
    [permissions],
  )

  return {
    permissions,
    checkPermission,
  }
}
